import axios from 'axios';
import { AppConfig } from './../config';


export const GET_PRESIGNED_URL = (data: any): Promise<any> => {
    return axios.post(`https://demo.vyaparlive.com/file`, data);
};
